// removed by extract-text-webpack-plugin
module.exports = {"field":"antd-pro-charts--field-field"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Charts/Field/index.less
// module id = 604
// module chunks = 0